import { useCallback } from 'react';
import { useCancelPresaveCampaignMutation } from '../../../redux/api/fymAPI';
import { isSuccessfulResult } from '../../../redux/api/utils/isSuccessfulResult';

interface UseCancelCampaignProps {
  accountId: number;
  campaignId: number;
  /** Passed through so the panel's cache entry, keyed by uuid, is dropped too. */
  campaignUuid?: string;
  smartLinkId: number;
}

/**
 * Calls off a campaign. The page stays up, the block stops taking sign-ups and
 * the fans who signed up are kept, so the counts on the panel still read true.
 */
export function useCancelCampaign({ accountId, campaignId, campaignUuid, smartLinkId }: UseCancelCampaignProps) {
  const [cancelPresaveCampaign, { isLoading, error, reset }] = useCancelPresaveCampaignMutation();

  const cancel = useCallback(async (): Promise<boolean> => {
    const result = await cancelPresaveCampaign({ accountId, campaignId, campaignUuid, smartLinkId });
    return isSuccessfulResult(result);
  }, [accountId, campaignId, campaignUuid, cancelPresaveCampaign, smartLinkId]);

  return { cancel, isLoading, error, reset };
}
